/* =========================================
   Character artwork
========================================= */

import kisukeImage from '../img/character/kisuke.png';
import momohimeImage from '../img/character/momohime.png';
import gonbeImage from '../img/character/gonbe.png';
import okoiImage from '../img/character/okoi.png';
import arashimaruImage from '../img/character/arashimaru.png';
import rajakiImage from '../img/character/rajaki.png';

/* =========================================
   Character hero backgrounds
========================================= */

import kisukeBackgroundMobile from '../img/character/kisuke_bg_sm.jpg';
import kisukeBackgroundDesktop from '../img/character/kisuke_bg.jpg';

import momohimeBackgroundMobile from '../img/character/momohime_bg_sm.jpg';
import momohimeBackgroundDesktop from '../img/character/momohime_bg.jpg';

import gonbeBackgroundMobile from '../img/character/gonbe_bg_sm.jpg';
import gonbeBackgroundDesktop from '../img/character/gonbe_bg.jpg';

import okoiBackgroundMobile from '../img/character/okoi_bg_sm.jpg';
import okoiBackgroundDesktop from '../img/character/okoi_bg.jpg';

import arashimaruBackgroundMobile from '../img/character/arashimaru_bg_sm.jpg';
import arashimaruBackgroundDesktop from '../img/character/arashimaru_bg.jpg';

import rajakiBackgroundMobile from '../img/character/rajaki_bg_sm.jpg';
import rajakiBackgroundDesktop from '../img/character/rajaki_bg.jpg';

/* =========================================
   Character scroll artwork
========================================= */

import kisukeScrollMobile from '../img/character/kisuke_scroll_sm.png';
import kisukeScrollDesktop from '../img/character/kisuke_scroll.png';

import momohimeScrollMobile from '../img/character/momohime_scroll_sm.png';
import momohimeScrollDesktop from '../img/character/momohime_scroll.png';

import gonbeScrollMobile from '../img/character/gonbe_scroll_sm.png';
import gonbeScrollDesktop from '../img/character/gonbe_scroll.png';

import okoiScrollMobile from '../img/character/okoi_scroll_sm.png';
import okoiScrollDesktop from '../img/character/okoi_scroll.png';

import arashimaruScrollMobile from '../img/character/arashimaru_scroll_sm.png';
import arashimaruScrollDesktop from '../img/character/arashimaru_scroll.png';

import rajakiScrollMobile from '../img/character/rajaki_scroll_sm.png';
import rajakiScrollDesktop from '../img/character/rajaki_scroll.png';

/* =========================================
   Character tiles
========================================= */

import kisukeTile from '../img/character/kisuke_tile.png';
import momohimeTile from '../img/character/momohime_tile.png';
import gonbeTile from '../img/character/gonbe_tile.png';
import okoiTile from '../img/character/okoi_tile.png';
import arashimaruTile from '../img/character/arashimaru_tile.png';
import rajakiTile from '../img/character/rajaki_tile.png';

/* =========================================
   Small character artwork
========================================= */

import kisukeSmall1 from '../img/character/kisuke_sm1.png';
import kisukeSmall2 from '../img/character/kisuke_sm2.png';
import kisukeSmall3 from '../img/character/kisuke_sm3.png';

import momohimeSmall1 from '../img/character/momohime_sm1.png';
import momohimeSmall2 from '../img/character/momohime_sm2.png';
import momohimeSmall3 from '../img/character/momohime_sm3.png';

import gonbeSmall1 from '../img/character/gonbe_sm1.png';
import gonbeSmall2 from '../img/character/gonbe_sm2.png';
import gonbeSmall3 from '../img/character/gonbe_sm3.png';
import gonbeSmall4 from '../img/character/gonbe_sm4.png';

import okoiSmall1 from '../img/character/okoi_sm1.png';
import okoiSmall2 from '../img/character/okoi_sm2.png';
import okoiSmall3 from '../img/character/okoi_sm3.png';

import arashimaruSmall1 from '../img/character/arashimaru_sm1.png';
import arashimaruSmall2 from '../img/character/arashimaru_sm2.png';
import arashimaruSmall3 from '../img/character/arashimaru_sm3.png';

import rajakiSmall1 from '../img/character/rajaki_sm1.png';
import rajakiSmall2 from '../img/character/rajaki_sm2.png';
import rajakiSmall3 from '../img/character/rajaki_sm3.png';

import tempVideo from '../img/video/hero_video_sm.mp4';

import kisukeBanner from '../img/character/kisuke_banner.png';
import momohimeBanner from '../img/character/momohime_banner.png';
import gonbeBanner from '../img/character/gonbe_banner.png';
import okoiBanner from '../img/character/okoi_banner.png';
import arashimaruBanner from '../img/character/arashimaru_banner.png';
import rajakiBanner from '../img/character/rajaki_banner.png';

import rebirthLogo from '../img/common/rebirth_logo.png';
import genrokuLogo from '../img/common/genroku_logo.png';

/* =========================================
   Character ghost / kazari artwork
========================================= */

import kisukeGhost from '../img/character/kisuke_ghost.png';
import momohimeGhost from '../img/character/momohime_ghost.png';
import gonbeGhost from '../img/character/gonbe_ghost.png';
import okoiGhost from '../img/character/okoi_ghost.png';
import arashimaruGhost from '../img/character/arashimaru_ghost.png';
import rajakiGhost from '../img/character/rajaki_ghost.png';

const TEMP_CHARACTER_VIDEO = tempVideo;
const TEMP_STORY_VIDEO = tempVideo;

import kisukeStory1 from '../img/video/01.01A.mp4';
import kisukeStory2 from '../img/video/01.01B.mp4';
import kisukeCombat1 from '../img/video/01.01C.mp4';
import kisukeCombat2 from '../img/video/01.01D.mp4';
import momohimeStory1 from '../img/video/01.02A.mp4';
import momohimeStory2 from '../img/video/01.02B.mp4';
import momohimeCombat1 from '../img/video/01.02C.mp4';
import momohimeCombat2 from '../img/video/01.02D.mp4';
import okoiStory1 from '../img/video/01.03A.mp4';
import okoiCombat1 from '../img/video/01.03B.mp4';
import okoiCombat2 from '../img/video/01.03C.mp4';
import gonbeStory1 from '../img/video/01.04A.mp4';
import gonbeCombat1 from '../img/video/01.04B.mp4';
import gonbeCombat2 from '../img/video/01.04C.mp4';
import arashimaruStory1 from '../img/video/01.05A.mp4';
import arashimaruCombat1 from '../img/video/01.05B.mp4';
import arashimaruCombat2 from '../img/video/01.05C.mp4';
import rajakiStory1 from '../img/video/01.06A.mp4';
import rajakiCombat1 from '../img/video/01.06B.mp4';
import rajakiCombat2 from '../img/video/01.06C.mp4';

const characters = {
  kisuke: {
    name: 'Kisuke',
    motif: 'leaves',

    eyebrow: 'Guided by the Demon Blade',

    talePrefix: 'The Tale of',
    taleName: 'Kisuke',

    tagline: 'The Art of the Demon Blade',

    plaqueName: 'Kisuke',

    japaneseVoice: 'Hiroyuki Yoshino',
    englishVoice: 'Khoi Dao',

    bio: 'A young ninja on the run for crimes he has no memory of committing. The events that led him down his current path are also shrouded in mystery. As he searches for answers and an accursed blade, Kisuke throws himself into battle after battle.',

    images: {
      bioLogo: rebirthLogo,

      character: kisukeImage,

      scrollMobile: kisukeScrollMobile,
      scrollDesktop: kisukeScrollDesktop,

      backgroundMobile: kisukeBackgroundMobile,
      backgroundDesktop: kisukeBackgroundDesktop,

      tile: kisukeTile,
      banner: kisukeBanner,
      ghost: kisukeGhost,
    },

    combatArt: [
      {
        image: kisukeSmall1,

        desktop: {
          width: '39%',
          top: '-18%',
          left: '5%',
          x: '-30%',
          y: '-37%',
          zIndex: '1',
        },

        tablet: {
          width: '34%',
          top: '-18%',
          left: '5%',
          x: '-30%',
          y: '-37%',
          zIndex: '1',
        },

        mobile: {
          width: '52%',
          top: '-28%',
          left: '2%',
          x: '-20%',
          y: '-9%',
          zIndex: '1',
        },
      },
      {
        image: kisukeSmall2,

        desktop: {
          width: '48rem',
          top: '30%',
          right: '8%',
          x: '16%',
          y: '13%',
          zIndex: '3',
        },

        tablet: {
          width: '46rem',
          top: '30%',
          right: '8%',
          x: '16%',
          y: '13%',
          zIndex: '3',
        },

        mobile: {
          width: '40rem',
          top: '37%',
          right: '-2%',
          x: '16%',
          y: '5%',
          zIndex: '3',
        },
      },
      {
        image: kisukeSmall3,

        desktop: {
          width: '35%',
          bottom: '-10%',
          left: '-2%',
          x: '1%',
          y: '0',
          zIndex: '5',
        },

        tablet: {
          width: '31%',
          bottom: '-10%',
          left: '-2%',
          x: '1%',
          y: '0',
          zIndex: '5',
        },

        mobile: {
          width: '42%',
          bottom: '-2%',
          left: '2%',
          x: '-51%',
          y: '70%',
          zIndex: '5',
        },
      },
    ],

    plaqueColor: '#16469a',
    plaqueColorMiddle: '#0d3479',
    plaqueColorDark: '#071b50',
    borderColor: '#c8aa43',

    bannerOneDark: '#13265f',
    bannerOneMiddle: '#294ca5',
    bannerOneLight: '#6b2f96',

    bannerTwoDark: '#69258d',
    bannerTwoMiddle: '#3e3199',
    bannerTwoLight: '#0755a8',

    storyHeading: 'Story',

    combatEyebrow: 'How They Fight',
    combatHeading: 'Combat',

    combatLabels: ['Unleash the Power of the', 'Demon Blades and 108 Skills'],

    storyVideos: [
      {
        poster: '',
        video: kisukeStory1,
      },
      {
        poster: '',
        video: kisukeStory2,
      },
    ],

    combatVideos: [
      {
        poster: '',
        video: kisukeCombat1,
        description:
          "Freely switch between three types of blades in the heat of battle. Choose from swift <span class='combat-feature__underline'>normal swords, which excel at rapid strikes,</span> and mighty <span class='combat-feature__underline'>long swords, which deliver powerful, wide-reaching attacks.</span> Each sword is imbued with its own <span class='combat-feature__underline'>unique skill.</span> Mix and match swords and secret arts to create a combat style that's uniquely yours.",
      },
      {
        poster: '',
        video: kisukeCombat2,
        description:
          "With <span class='combat-feature__underline'>108 skills</span> to master, each consuming Spirit Power and offering distinct abilities, every battle rewards strategy, skill, and experimentation.",
      },
    ],
  },

  momohime: {
    name: 'Momohime',
    motif: 'petals',

    eyebrow: 'Two Souls, One Fateful Journey',

    talePrefix: 'The Tale of',
    taleName: 'Momohime',

    tagline: 'The Souls of the Oboro Style',

    plaqueName: 'Momohime',

    japaneseVoice: 'Miyuki Sawashiro',
    englishVoice: 'Alice Himora',

    bio: 'A high-ranking noblewoman of Narukami Domain in Mino Province. Her beauty rivals a flower in full bloom or freshly fallen snow. One day, an evil spirit possesses her, taking complete control of her body. Ever since she fled the castle grounds, her whereabouts have remained unknown.',

    images: {
      bioLogo: rebirthLogo,

      character: momohimeImage,

      scrollMobile: momohimeScrollMobile,
      scrollDesktop: momohimeScrollDesktop,

      backgroundMobile: momohimeBackgroundMobile,
      backgroundDesktop: momohimeBackgroundDesktop,

      tile: momohimeTile,
      banner: momohimeBanner,
      ghost: momohimeGhost,
    },

    combatArt: [
      {
        image: momohimeSmall1,

        desktop: {
          width: '56%',
          top: '-34%',
          left: '-10%',
          x: '-5%',
          y: '-5%',
          zIndex: '1',
        },

        tablet: {
          width: '50%',
          top: '-34%',
          left: '-10%',
          x: '-5%',
          y: '-5%',
          zIndex: '1',
        },

        mobile: {
          width: '53rem',
          top: '-41%',
          left: '-18%',
          x: '-35%',
          y: '-2%',
          zIndex: '1',
        },
        smMobile: {
          width: '53rem',
          top: '-41%',
          left: '-37%',
          x: '0',
          y: '0',
          zIndex: '1',
        },
      },
      {
        image: momohimeSmall2,

        desktop: {
          width: '52rem',
          top: '19%',
          right: '-2%',
          x: '-10%',
          y: '-3%',
          zIndex: '1',
        },

        mobile: {
          width: '55rem',
          top: '30%',
          right: '-2%',
          x: '11%',
          y: '-14%',
          zIndex: '1',
        },
      },
      {
        image: momohimeSmall3,

        desktop: {
          width: '36%',
          bottom: '-10%',
          left: '-2%',
          x: '0%',
          y: '10%',
          zIndex: '5',
        },

        tablet: {
          width: '31%',
          bottom: '-10%',
          left: '-2%',
          x: '0%',
          y: '10%',
          zIndex: '5',
        },

        mobile: {
          width: '57%',
          bottom: '-12%',
          left: '2%',
          x: '-51%',
          y: '37%',
          zIndex: '5',
        },
      },
    ],

    plaqueColor: '#8d154c',
    plaqueColorMiddle: '#681039',
    plaqueColorDark: '#3f0928',
    borderColor: '#d2b64d',

    bannerOneDark: '#6f164b',
    bannerOneMiddle: '#a51f69',
    bannerOneLight: '#d13684',

    bannerTwoDark: '#c62d7c',
    bannerTwoMiddle: '#9d1f66',
    bannerTwoLight: '#65143f',

    storyHeading: 'Story',

    combatEyebrow: 'How She Fights',
    combatHeading: 'Combat',

    combatLabels: ['Unleash the Power of the', 'Demon Blades and 108 Skills'],

    storyVideos: [
      {
        poster: './img/character/momohime_story1.jpg',
        video: momohimeStory1,
      },
      {
        poster: './img/character/momohime_story2.jpg',
        video: momohimeStory2,
      },
    ],

    combatVideos: [
      {
        poster: './img/character/momohime_combat1.jpg',
        video: momohimeCombat1,
        description:
          "Similar to Kisuke, freely switch between three swords in the heat of battle. Wield two distinct types of swords: swift <span class='combat-feature__underline'>normal blades</span>, which excel at combo attacks, and mighty <span class='combat-feature__underline'>long blades</span>, which deliver devastating power at the cost of speed. Each sword is imbued with its own unique <span class='combat-feature__underline'>skill</span>. Mix and match swords and skills to create a combat style that's uniquely yours.",
      },
      {
        poster: './img/character/momohime_combat2.jpg',
        video: momohimeCombat2,
        description:
          "With <span class='combat-feature__underline'>108 skills</span> to master, you'll have access to a wide variety of abilities, from powerful single-target strikes to long-range attacks that can take down distant enemies.",
      },
    ],
  },

  gonbe: {
    name: 'Gonbe',
    motif: 'leaves',

    eyebrow: 'Stand together. We must protect our village!',

    talePrefix: 'The Tale of the',
    taleName: 'Rebellion',

    tagline: 'Seeds of Dissent',

    plaqueName: 'Gonbe',

    japaneseVoice: 'Shintaro Asanuma',
    englishVoice: 'Adin Rudd',

    bio: "The most diligent, hard-working farmer of his humble village. Mainly makes his living by growing rice and daikon. Ever since his beloved wife passed away from illness a year ago, he's lived the solitary life of a widower.",

    images: {
      bioLogo: genrokuLogo,

      character: gonbeImage,

      scrollMobile: gonbeScrollMobile,
      scrollDesktop: gonbeScrollDesktop,

      backgroundMobile: gonbeBackgroundMobile,
      backgroundDesktop: gonbeBackgroundDesktop,

      tile: gonbeTile,
      banner: gonbeBanner,
      ghost: gonbeGhost,
    },

    combatArt: [
      {
        image: gonbeSmall1,

        desktop: {
          width: '100%',
          top: '-23%',
          left: '-6%',
          x: '-5%',
          y: '-21%',
          zIndex: '0',
        },

        tablet: {
          width: '92%',
          top: '-23%',
          left: '-6%',
          x: '-5%',
          y: '-21%',
          zIndex: '0',
        },

        mobile: {
          width: '124%',
          top: '-34%',
          left: '-13%',
          x: '-5%',
          y: '8%',
          zIndex: '0',
        },
      },
      {
        image: gonbeSmall2,

        desktop: {
          width: '36.5rem',
          top: '27%',
          right: '-3%',
          x: '-22%',
          y: '-6%',
          zIndex: '3',
        },

        tablet: {
          width: '32rem',
          top: '27%',
          right: '-3%',
          x: '-22%',
          y: '-6%',
          zIndex: '3',
        },

        mobile: {
          width: '37rem',
          top: '37%',
          right: '-7%',
          x: '-12%',
          y: '1%',
          zIndex: '3',
        },
        smMobile: {
          width: '37rem',
          top: '37%',
          right: '-7%',
          x: '-2%',
          y: '-8%',
          zIndex: '3',
        },
      },
      {
        image: gonbeSmall3,

        desktop: {
          width: '36%',
          bottom: '-4%',
          left: '-7%',
          x: '13%',
          y: '8%',
          zIndex: '5',
        },

        tablet: {
          width: '31%',
          bottom: '-4%',
          left: '-7%',
          x: '13%',
          y: '8%',
          zIndex: '5',
        },
        mobile: {
          width: '52%',
          bottom: '-8%',
          left: '-14%',
          x: '-12%',
          y: '36%',
          zIndex: '5',
        },
        smMobile: {
          width: '52%',
          bottom: '-8%',
          left: '-14%',
          x: '-21%',
          y: '27%',
          zIndex: '5',
        },
      },
      {
        image: gonbeSmall4,

        desktop: {
          width: '30rem',
          bottom: '33%',
          left: '-7%',
          x: '21%',
          y: '3%',
          zIndex: '5',
        },

        tablet: {
          width: '27rem',
          bottom: '31%',
          left: '-6%',
          x: '21%',
          y: '3%',
          zIndex: '5',
        },

        mobile: {
          width: '30rem',
          bottom: '33%',
          left: '-7%',
          x: '16%',
          y: '1%',
          zIndex: '5',
        },

        smMobile: {
          width: '30rem',
          bottom: '33%',
          left: '-7%',
          x: '-44%',
          y: '1%',
          zIndex: '5',
        },
      },
    ],

    plaqueColor: '#247628',
    plaqueColorMiddle: '#17601f',
    plaqueColorDark: '#0b3a18',
    borderColor: '#d2b64d',

    bannerOneDark: '#2f6120',
    bannerOneMiddle: '#5f9a3d',
    bannerOneLight: '#94c66a',

    bannerTwoDark: '#4f7d22',
    bannerTwoMiddle: '#3d7a2e',
    bannerTwoLight: '#2a6225',

    storyHeading: 'Story',

    combatEyebrow: 'How He Fights',
    combatHeading: 'Combat',

    combatLabels: ['Rally Your Allies', 'and Fight Together'],

    storyVideos: [
      {
        poster: './img/character/gonbe_story1.jpg',
        video: gonbeStory1,
      },
    ],

    combatVideos: [
      {
        poster: './img/character/gonbe_combat1.jpg',
        video: gonbeCombat1,
        description:
          "Switch between three types of weapons, each with their own unique strengths. Deliver devastating blows with the <span class='combat-feature__underline'>hoe</span>, unleash rapid attacks with the <span class='combat-feature__underline'>bamboo spear</span>, or strike from a distance with <span class='combat-feature__underline'>sickles</span> to adapt to any enemy.",
      },
      {
        poster: './img/character/gonbe_combat2.jpg',
        video: gonbeCombat2,
        description:
          "Fill your spirit gauge to call your <span class='combat-feature__underline'>allies to battle</span>, unleashing a <span class='combat-feature__underline'>powerful area attack</span> while summoning <span class='combat-feature__underline'>Tagosaku and Moheji</span> to fight alongside you. You can also team up with the <span class='combat-feature__underline'>ghost Otae to unleash powerful combo attacks</span> and overwhelm your foes.",
      },
    ],
  },

  okoi: {
    name: 'Okoi',
    motif: 'petals',

    eyebrow: 'The Bakeneko Incident Born of Resentment',

    talePrefix: 'The Tale of the',
    taleName: 'Bakeneko',

    tagline: 'The Feline Fiend of Tsunakama',

    plaqueName: 'Okoi',

    japaneseVoice: 'Rina Hidaka',
    englishVoice: 'Sam Slade',

    bio: "The eldest daughter of Lord Kenmochi Inukai, chief retainer to the Edo shogun. In her father's absence, Okoi watches over the family estate with her younger brother, Seijiro. Her strong will, upstanding character, and striking beauty have won her many marriage proposals, all of which she turned down in favor of keeping an eye on her brother.",

    images: {
      bioLogo: genrokuLogo,

      character: okoiImage,

      scrollMobile: okoiScrollMobile,
      scrollDesktop: okoiScrollDesktop,

      backgroundMobile: okoiBackgroundMobile,
      backgroundDesktop: okoiBackgroundDesktop,

      tile: okoiTile,
      banner: okoiBanner,
      ghost: okoiGhost,
    },

    combatArt: [
      {
        image: okoiSmall1,

        desktop: {
          width: '120%',
          top: '-25%',
          left: '-13%',
          x: '-8%',
          y: '5%',
          zIndex: '0',
        },
        tablet: {
          width: '95%',
          top: '-25%',
          left: '0%',
          x: '-8%',
          y: '5%',
          zIndex: '0',
        },

        mobile: {
          width: '110%',
          top: '-22%',
          left: '-4%',
          x: '-15%',
          y: '5%',
          zIndex: '0',
        },
      },
      {
        image: okoiSmall2,

        desktop: {
          width: '51rem',
          top: '12%',
          right: '-10%',
          x: '10%',
          y: '-7%',
          zIndex: '3',
        },

        tablet: {
          width: '45rem',
          top: '18%',
          right: '-7%',
          x: '10%',
          y: '-7%',
          zIndex: '3',
        },
        mobile: {
          width: '40rem',
          top: '23%',
          right: '-4%',
          x: '48%',
          y: '0',
          zIndex: '3',
        },
      },
      {
        image: okoiSmall3,

        desktop: {
          width: '45%',
          bottom: '-1%',
          left: '-12%',
          x: '9%',
          y: '0',
          zIndex: '5',
        },

        tablet: {
          width: '38%',
          bottom: '-1%',
          left: '-12%',
          x: '9%',
          y: '0',
          zIndex: '5',
        },

        mobile: {
          width: '56%',
          bottom: '4%',
          left: '-17%',
          x: '-9%',
          y: '87%',
          zIndex: '5',
        },
      },
    ],

    plaqueColor: '#7c157e',
    plaqueColorMiddle: '#55105b',
    plaqueColorDark: '#38063f',
    borderColor: '#d2b64d',

    bannerOneDark: '#4c146e',
    bannerOneMiddle: '#78249a',
    bannerOneLight: '#a348c0',

    bannerTwoDark: '#8b1f91',
    bannerTwoMiddle: '#6d197d',
    bannerTwoLight: '#481052',

    storyHeading: 'Story',

    combatEyebrow: 'How She Fights',
    combatHeading: 'Combat',

    combatLabels: ['Outwit Enemies with', 'Two Distinct Forms'],

    storyVideos: [
      {
        poster: './img/character/okoi_story1.jpg',
        video: okoiStory1,
      },
    ],

    combatVideos: [
      {
        poster: './img/character/okoi_combat1.jpg',
        video: okoiCombat1,
        description:
          "Switch seamlessly between <span class='combat-feature__underline'>Okoi</span>, who tears through enemies with swift claw attacks, and <span class='combat-feature__underline'>Miké</span>, who commands whisps from a distance.",
      },
      {
        poster: './img/character/okoi_combat2.jpg',
        video: okoiCombat2,
        description:
          "When your <span class='combat-feature__underline'>Transformation Gauge</span> is full, unleash the immense power of the giant <span class='combat-feature__underline'>Bakeneko</span> to devastate enemies with powerful wide-area attacks.",
      },
    ],
  },

  arashimaru: {
    name: 'Arashimaru',
    motif: 'leaves',

    eyebrow: 'Seven days bound by blood, the end draws near.',

    talePrefix: 'The Tale of the',
    taleName: 'White Snake',

    tagline: 'Seven Haunting Nights',

    plaqueName: 'Arashimaru',

    japaneseVoice: 'Ryota Osaka',
    englishVoice: 'Caleb Yen',

    bio: 'An assassin of the Mukuro ninja clan, which operates in the shadows of Iga Province. When Arashimaru goes rogue and turns on his former masters, his survival depends on the skills he learned from his mentor, Shiranui. His weapons of choice include the chain-sickle, kunai, and explosive smoke bombs.',

    images: {
      bioLogo: genrokuLogo,

      character: arashimaruImage,

      scrollMobile: arashimaruScrollMobile,
      scrollDesktop: arashimaruScrollDesktop,

      backgroundMobile: arashimaruBackgroundMobile,
      backgroundDesktop: arashimaruBackgroundDesktop,

      tile: arashimaruTile,
      banner: arashimaruBanner,
      ghost: arashimaruGhost,
    },

    combatArt: [
      {
        image: arashimaruSmall1,

        desktop: {
          width: '59.5rem',
          top: '-30%',
          left: '-10%',
          x: '3%',
          y: '-7%',
          zIndex: '0',
        },

        tablet: {
          width: '56.5rem',
          top: '-30%',
          left: '-10%',
          x: '3%',
          y: '-7%',
          zIndex: '0',
        },

        mobile: {
          width: '65rem',
          top: '-27%',
          left: '-2%',
          x: '-12%',
          y: '-16%',
          zIndex: '0',
        },
      },
      {
        image: arashimaruSmall2,

        desktop: {
          width: '55rem',
          top: '12%',
          right: '-20%',
          x: '-35%',
          y: '-5%',
          zIndex: '3',
        },

        tablet: {
          width: '52.5rem',
          top: '12%',
          right: '-20%',
          x: '-35%',
          y: '-5%',
          zIndex: '3',
        },

        mobile: {
          width: '40rem',
          top: '23%',
          right: '-6rem',
          x: '3%',
          y: '-10%',
          zIndex: '3',
        },
      },
      {
        image: arashimaruSmall3,

        desktop: {
          width: '70rem',
          bottom: '-1rem',
          left: '-27rem',
          x: '0',
          y: '0',
          zIndex: '5',
        },

        tablet: {
          width: '64rem',
          bottom: '-1rem',
          left: '-27rem',
          x: '0',
          y: '0',
          zIndex: '5',
        },

        mobile: {
          width: '70rem',
          bottom: '-32rem',
          left: '-20rem',
          x: '-20%',
          y: '-5%',
          zIndex: '1',
        },
      },
    ],

    plaqueColor: '#13776f',
    plaqueColorMiddle: '#0c5b58',
    plaqueColorDark: '#063c41',
    borderColor: '#d2b64d',

    bannerOneDark: '#123d3d',
    bannerOneMiddle: '#176b66',
    bannerOneLight: '#4ca79d',

    bannerTwoDark: '#2b736d',
    bannerTwoMiddle: '#3f938a',
    bannerTwoLight: '#62bbb0',

    storyHeading: 'Story',

    combatEyebrow: 'How He Fights',
    combatHeading: 'Combat',

    combatLabels: ['Subdue Enemies with', 'Ninja Skills and Sorcery'],

    storyVideos: [
      {
        poster: './img/character/arashimaru_story1.jpg',
        video: arashimaruStory1,
      },
    ],

    combatVideos: [
      {
        poster: './img/character/arashimaru_combat1.jpg',
        video: arashimaruCombat1,
        description:
          "Switch freely between the <span class='combat-feature__underline'>kunai, chain-sickle, and bombs</span>, three weapons designed for <span class='combat-feature__underline'>mid- and long-range combat</span>. Adapt to every encounter by pressuring enemies from a distance, sweeping through groups of foes, and keeping danger at bay.",
      },
      {
        poster: './img/character/arashimaru_combat2.jpg',
        video: arashimaruCombat2,
        description:
          "Activate Secret Arts in midair to summon <span class='combat-feature__underline'>Shirohebi</span>, whose <span class='combat-feature__underline'>powerful attacks</span> can turn the tide against hordes of enemies or powerful adversaries.",
      },
    ],
  },

  rajaki: {
    name: 'Rajaki',
    motif: 'petals',

    eyebrow: 'The Wild Adventures of the Oni Girl',

    talePrefix: 'The Tale of the',
    taleName: "Devil's Daughter",

    tagline: 'Unholy Matrimony',

    plaqueName: 'Rajaki',

    japaneseVoice: 'Kumiko Watanabe',
    englishVoice: 'Suzie Yeung',

    bio: 'The youngest daughter of Lord Enma, ruler of Hell. Brandishes a fiery battle axe that belies her diminutive stature. Announces herself as "Rajaki the Infernal" with great fanfare to intimidate her foes.',

    images: {
      bioLogo: genrokuLogo,

      character: rajakiImage,

      scrollMobile: rajakiScrollMobile,
      scrollDesktop: rajakiScrollDesktop,

      backgroundMobile: rajakiBackgroundMobile,
      backgroundDesktop: rajakiBackgroundDesktop,

      tile: rajakiTile,
      banner: rajakiBanner,
      ghost: rajakiGhost,
    },

    combatArt: [
      {
        image: rajakiSmall1,

        desktop: {
          width: '31%',
          top: '-36rem',
          left: '-4rem',
          x: '0',
          y: '0',
        },

        tablet: {
          width: '26.5%',
          top: '-36rem',
          left: '-4rem',
          x: '0',
          y: '0',
        },

        mobile: {
          width: '28rem',
          top: '-32rem',
          left: '-6rem',
          x: '0',
          y: '0',
        },

        smMobile: {
          width: '28rem',
          top: '-42rem',
          left: '-15rem',
          x: '0',
          y: '0',
        },
      },
      {
        image: rajakiSmall2,

        desktop: {
          width: '31rem',
          top: '28rem',
          right: '6rem',
          x: '0',
          y: '0',
          zIndex: '3',
        },

        tablet: {
          width: '29rem',
          top: '28rem',
          right: '6rem',
          x: '0',
          y: '0',
          zIndex: '3',
        },
        mobile: {
          width: 'clamp(24rem, 28vw, 31rem)',

          top: 'calc(14% + 2rem)',
          right: 'calc(0% + 2rem)',
          x: '0',
          y: '0',
          zIndex: '3',
        },
      },
      {
        image: rajakiSmall3,

        desktop: {
          width: '47%',
          bottom: '-19%',
          left: '-12%',
          x: '3%',
          y: '9%',
          zIndex: '5',
        },

        tablet: {
          width: '42%',
          bottom: '-19%',
          left: '-12%',
          x: '3%',
          y: '9%',
          zIndex: '5',
        },
        mobile: {
          width: '59%',
          bottom: '-37%',
          left: '-24%',
          x: '0',
          y: '0',
          zIndex: '5',
        },
        smMobile: {
          width: '59%',
          bottom: '-33%',
          left: '-26%',
          x: '0',
          y: '0',
          zIndex: '5',
        },
      },
    ],

    plaqueColor: '#8a7810',
    plaqueColorMiddle: '#66590a',
    plaqueColorDark: '#473c05',
    borderColor: '#d2b64d',

    bannerOneDark: '#5a4a0c',
    bannerOneMiddle: '#8a7418',
    bannerOneLight: '#b3932e',

    bannerTwoDark: '#a1841f',
    bannerTwoMiddle: '#786216',
    bannerTwoLight: '#4d3f0b',

    storyHeading: 'Story',

    combatEyebrow: 'How She Fights',
    combatHeading: 'Combat',

    combatLabels: ['Unleash Three', 'Demonic Forms'],

    storyVideos: [
      {
        poster: './img/character/rajaki_story1.jpg',
        video: rajakiStory1,
      },
    ],

    combatVideos: [
      {
        poster: './img/character/rajaki_combat1.jpg',
        video: rajakiCombat1,
        description:
          "Harness the power of the mallet to switch between <span class='combat-feature__underline'>Hellion</span> and <span class='combat-feature__underline'>Hellraiser</span> forms, each offering a unique fighting style. Chain swift combos in <span class='combat-feature__underline'>Hellion</span> form or unleash devastating single strikes in <span class='combat-feature__underline'>Hellraiser</span> form to adapt to every battle. Land consecutive attacks to trigger going <span class='combat-feature__underline'>Berserk</span>, empowering your abilities with extended combos and <span class='combat-feature__underline'>follow-up fire pillar attacks</span>.",
      },
      {
        poster: './img/character/rajaki_combat2.jpg',
        video: rajakiCombat2,
        description:
          "Fill the <span class='combat-feature__underline'>Giant Gauge</span> to become a <span class='combat-feature__underline'>Giant</span>, overwhelming enemies with immense power and temporary invincibility.",
      },
    ],
  },
};

/* =========================================
   Page elements
========================================= */

const characterPage = document.querySelector('[data-character-page]');

const characterTiles = Array.from(
  document.querySelectorAll('.character-tile[data-character]'),
);

const characterElements = {
  eyebrow: document.querySelectorAll('[data-character-eyebrow]'),

  talePrefix: document.querySelectorAll('[data-character-tale-prefix]'),

  taleName: document.querySelectorAll('[data-character-tale-name]'),

  tagline: document.querySelectorAll('[data-character-tagline]'),

  ghostImage: document.querySelectorAll('[data-character-ghost-image]'),

  characterImages: document.querySelectorAll('[data-character-image]'),

  plaqueBanner: document.querySelectorAll('[data-character-plaque-banner]'),

  plaqueName: document.querySelectorAll('[data-character-plaque-name]'),

  japaneseVoice: document.querySelectorAll('[data-character-japanese-voice]'),

  englishVoice: document.querySelectorAll('[data-character-english-voice]'),

  bioLogo: document.querySelectorAll('[data-character-bio-logo]'),

  bio: document.querySelectorAll('[data-character-bio]'),

  mobileScrolls: document.querySelectorAll('[data-character-scroll-mobile]'),

  desktopScrolls: document.querySelectorAll('[data-character-scroll-desktop]'),

  heroSources: document.querySelectorAll('[data-character-hero-source]'),

  heroImages: document.querySelectorAll('[data-character-hero-image]'),

  storyHeading: document.querySelector('[data-character-story-heading]'),

  storyVideosContainer: document.querySelector('[data-character-story-videos]'),

  combatEyebrow: document.querySelectorAll('[data-character-combat-eyebrow]'),

  combatHeading: document.querySelectorAll('[data-character-combat-heading]'),

  combatLabels: document.querySelectorAll('[data-character-combat-label]'),

  combatMedia: document.querySelectorAll('[data-character-combat-media]'),

  combatCopy: document.querySelectorAll('[data-character-combat-copy]'),

  combatArt: document.querySelectorAll('[data-character-combat-art]'),

  motifContainers: document.querySelectorAll('[data-character-motif]'),
};

/* =========================================
   Responsive state
========================================= */

const combatTabletMedia = window.matchMedia('(max-width: 1100px)');
const combatMobileMedia = window.matchMedia('(max-width: 900px)');
const combatSmallMobileMedia = window.matchMedia('(max-width: 470px)');

const motifReducedMotionMedia = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
);

/* =========================================
   Switching state
========================================= */

let activeCharacter = null;
let isTransitioning = false;
let motifTicking = false;

/* =========================================
   Helper functions
========================================= */

function setText(elements, value) {
  elements.forEach((element) => {
    element.textContent = value ?? '';
  });
}

function setImage(elements, src, alt = '') {
  elements.forEach((element) => {
    element.src = src;
    element.alt = alt;
  });
}

function preloadImages(urls) {
  const uniqueUrls = [...new Set(urls.filter(Boolean))];

  return Promise.all(
    uniqueUrls.map(
      (url) =>
        new Promise((resolve) => {
          const image = new Image();

          image.onload = resolve;
          image.onerror = resolve;

          image.src = url;
        }),
    ),
  );
}

function waitForOpacityTransition(element) {
  return new Promise((resolve) => {
    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    if (reducedMotion || !element) {
      resolve();

      return;
    }

    let completed = false;

    const finish = () => {
      if (completed) {
        return;
      }

      completed = true;

      element.removeEventListener('transitionend', handleTransitionEnd);

      resolve();
    };

    const handleTransitionEnd = (event) => {
      if (event.target === element && event.propertyName === 'opacity') {
        finish();
      }
    };

    element.addEventListener('transitionend', handleTransitionEnd);

    /*
     * Fallback in case transitionend
     * doesn't fire.
     */
    window.setTimeout(finish, 500);
  });
}

/* =========================================
   Character scroll motif
========================================= */

function renderCharacterMotif(character) {
  const motif = character.motif ?? 'leaves';

  characterElements.motifContainers.forEach((container) => {
    const groups = container.querySelectorAll('[data-motif]');

    groups.forEach((group) => {
      const isActive = group.dataset.motif === motif;

      group.classList.toggle('is-active', isActive);
    });
  });

  /*
   * A character can be changed while the page
   * is already scrolled into this section.
   *
   * Updating immediately puts the newly active
   * leaves / petals at the correct scroll position.
   */
  requestCharacterMotifUpdate();
}

function updateCharacterMotifs() {
  if (!characterElements.motifContainers.length) {
    return;
  }

  /*
   * Reduced motion leaves the decorations in
   * their normal CSS positions.
   */
  if (motifReducedMotionMedia.matches) {
    characterElements.motifContainers.forEach((container) => {
      container.querySelectorAll('[data-motif-speed]').forEach((piece) => {
        piece.style.transform = '';
      });
    });

    return;
  }

  const viewportHeight = window.innerHeight;

  characterElements.motifContainers.forEach((container) => {
    const section =
      container.closest('.character-scroll-intro__scroll') ||
      container.closest('.character-scroll-intro-large');

    if (!section) {
      return;
    }

    const activeGroup = container.querySelector(
      '.character-scroll-motif__group.is-active',
    );

    if (!activeGroup) {
      return;
    }

    const rect = section.getBoundingClientRect();

    /*
     * Progress begins at 0 when the section reaches
     * the bottom of the viewport and reaches 1 when
     * the entire section has passed above it.
     */
    const totalTravel = viewportHeight + rect.height;

    const progress = Math.min(
      Math.max((viewportHeight - rect.top) / totalTravel, 0),
      1,
    );

    /*
     * Base travel for the motif.
     *
     * Each individual leaf / petal multiplies this
     * value by its own data-motif-speed.
     */
    const baseTravel = 420;

    activeGroup.querySelectorAll('[data-motif-speed]').forEach((piece) => {
      const speed = Number(piece.dataset.motifSpeed) || 0.2;

      const y = progress * baseTravel * speed;

      piece.style.transform = `translate3d(0, ${y}px, 0)`;
    });
  });
}

function requestCharacterMotifUpdate() {
  if (motifTicking) {
    return;
  }

  motifTicking = true;

  window.requestAnimationFrame(() => {
    updateCharacterMotifs();

    motifTicking = false;
  });
}

function setupCharacterMotifMotion() {
  if (!characterElements.motifContainers.length) {
    return;
  }

  window.addEventListener('scroll', requestCharacterMotifUpdate, {
    passive: true,
  });

  window.addEventListener('resize', requestCharacterMotifUpdate);

  motifReducedMotionMedia.addEventListener(
    'change',
    requestCharacterMotifUpdate,
  );

  requestCharacterMotifUpdate();
}

/* =========================================
   Story videos
========================================= */

function renderStoryVideos(character) {
  const container = characterElements.storyVideosContainer;

  if (!container) {
    return;
  }

  if (characterElements.storyHeading) {
    characterElements.storyHeading.textContent =
      character.storyHeading ?? 'Story';
  }

  /*
   * Remove the previous character's
   * story videos.
   */
  container.innerHTML = '';

  /*
   * Build however many story video
   * slots exist for this character.
   *
   * For now, every slot uses the same
   * temporary placeholder video.
   */
  character.storyVideos.forEach((videoData) => {
    const article = document.createElement('article');

    article.className = 'story-feature';

    const videoWrapper = document.createElement('div');

    videoWrapper.className = 'story-feature__video';

    const frame = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    frame.setAttribute('class', 'story-feature__frame');
    frame.setAttribute('viewBox', '0 0 480 270');
    frame.setAttribute('preserveAspectRatio', 'none');
    frame.setAttribute('aria-hidden', 'true');

    const framePath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path',
    );

    framePath.setAttribute(
      'd',
      `
      M 6,1
      L 474,1
      A 6,6 0 0 0 479,6
      L 479,264
      A 6,6 0 0 0 474,269
      L 6,269
      A 6,6 0 0 0 1,264
      L 1,6
      A 6,6 0 0 0 6,1
      Z
    `,
    );

    framePath.setAttribute('fill', 'none');
    framePath.setAttribute('stroke', 'rgb(231, 219, 168)');
    framePath.setAttribute('stroke-width', '2');
    framePath.setAttribute('vector-effect', 'non-scaling-stroke');

    frame.appendChild(framePath);

    const video = document.createElement('video');

    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';

    const source = document.createElement('source');

    source.src = videoData.video;
    source.type = 'video/mp4';

    video.appendChild(source);

    videoWrapper.appendChild(frame);
    videoWrapper.appendChild(video);

    article.appendChild(videoWrapper);

    container.appendChild(article);
  });
}

/* =========================================
   Combat artwork
========================================= */

function renderCombatArt(character) {
  const isTablet = combatTabletMedia.matches;
  const isMobile = combatMobileMedia.matches;

  characterElements.combatArt.forEach((element) => {
    const index = Number(element.dataset.characterCombatArt);

    const art = character.combatArt?.[index];

    if (!art) {
      element.hidden = true;

      element.removeAttribute('src');

      element.style.top = 'auto';
      element.style.right = 'auto';
      element.style.bottom = 'auto';
      element.style.left = 'auto';
      element.style.zIndex = '';

      element.style.removeProperty('--combat-art-width');
      element.style.removeProperty('--combat-art-height');
      element.style.removeProperty('--combat-art-x');
      element.style.removeProperty('--combat-art-y');

      return;
    }

    const isSmallMobile = combatSmallMobileMedia.matches;

    const layout = isSmallMobile
      ? (art.smMobile ?? art.mobile ?? art.tablet ?? art.desktop)
      : isMobile
        ? (art.mobile ?? art.tablet ?? art.desktop)
        : isTablet
          ? (art.tablet ?? art.desktop)
          : (art.desktop ?? art.mobile);

    if (!layout) {
      element.hidden = true;

      element.removeAttribute('src');

      element.style.top = 'auto';
      element.style.right = 'auto';
      element.style.bottom = 'auto';
      element.style.left = 'auto';
      element.style.zIndex = '';

      element.style.removeProperty('--combat-art-width');
      element.style.removeProperty('--combat-art-height');
      element.style.removeProperty('--combat-art-x');
      element.style.removeProperty('--combat-art-y');

      return;
    }

    element.hidden = false;

    element.src = art.image;
    element.alt = '';

    element.style.top = 'auto';
    element.style.right = 'auto';
    element.style.bottom = 'auto';
    element.style.left = 'auto';
    element.style.zIndex = '';

    element.style.removeProperty('--combat-art-width');
    element.style.removeProperty('--combat-art-height');
    element.style.removeProperty('--combat-art-x');
    element.style.removeProperty('--combat-art-y');

    element.style.top = layout.top ?? 'auto';
    element.style.right = layout.right ?? 'auto';
    element.style.bottom = layout.bottom ?? 'auto';
    element.style.left = layout.left ?? 'auto';

    if (layout.zIndex !== undefined) {
      element.style.zIndex = String(layout.zIndex);
    }

    if (layout.width) {
      element.style.setProperty('--combat-art-width', layout.width);
    }

    if (layout.height) {
      element.style.setProperty('--combat-art-height', layout.height);
    }

    element.style.setProperty('--combat-art-x', layout.x ?? '0');

    element.style.setProperty('--combat-art-y', layout.y ?? '0');
  });
}

/* =========================================
   Update visible content
========================================= */

function updateCharacterContent(characterKey) {
  const character = characters[characterKey];

  if (!character || !characterPage) {
    console.warn(`Character "${characterKey}" was not found.`);

    return;
  }

  characterPage.dataset.character = characterKey;

  setImage(characterElements.ghostImage, character.images.ghost, '');
  setText(characterElements.eyebrow, character.eyebrow);

  setText(characterElements.talePrefix, character.talePrefix);

  setText(characterElements.taleName, character.taleName);

  setText(characterElements.tagline, character.tagline);

  setText(characterElements.plaqueName, character.plaqueName);

  setText(characterElements.japaneseVoice, character.japaneseVoice);

  setText(characterElements.englishVoice, character.englishVoice);

  setText(characterElements.bio, character.bio);

  setImage(
    characterElements.characterImages,
    character.images.character,
    character.name,
  );
  setImage(
    characterElements.plaqueBanner,
    character.images.banner,
    `${character.name} character banner`,
  );
  setImage(
    characterElements.bioLogo,
    character.images.bioLogo,
    `${character.name} previous title logo`,
  );

  setImage(characterElements.mobileScrolls, character.images.scrollMobile);

  setImage(characterElements.desktopScrolls, character.images.scrollDesktop);

  renderCharacterMotif(character);

  characterElements.heroSources.forEach((source) => {
    source.srcset = character.images.backgroundMobile;
  });

  setImage(
    characterElements.heroImages,
    character.images.backgroundDesktop,
    '',
  );

  renderStoryVideos(character);

  // setText(characterElements.combatEyebrow, character.combatEyebrow);

  setText(characterElements.combatHeading, character.combatHeading);

  characterElements.combatLabels.forEach((element) => {
    const index = Number(element.dataset.characterCombatLabel);

    element.textContent = character.combatLabels[index] ?? '';
  });

  characterElements.combatMedia.forEach((element) => {
    const index = Number(element.dataset.characterCombatMedia);
    const videoData = character.combatVideos[index];

    if (!videoData) {
      element.replaceChildren();

      return;
    }

    const frame = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    frame.setAttribute('class', 'combat-feature__frame');
    frame.setAttribute('viewBox', '0 0 480 270');
    frame.setAttribute('preserveAspectRatio', 'none');
    frame.setAttribute('aria-hidden', 'true');

    const framePath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path',
    );

    framePath.setAttribute(
      'd',
      `
      M 6,1
      L 474,1
      A 6,6 0 0 0 479,6
      L 479,264
      A 6,6 0 0 0 474,269
      L 6,269
      A 6,6 0 0 0 1,264
      L 1,6
      A 6,6 0 0 0 6,1
      Z
    `,
    );

    framePath.setAttribute('fill', 'none');
    framePath.setAttribute('stroke', 'rgb(231, 219, 168)');
    framePath.setAttribute('stroke-width', '2');
    framePath.setAttribute('vector-effect', 'non-scaling-stroke');

    frame.appendChild(framePath);

    const video = document.createElement('video');

    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';

    const source = document.createElement('source');

    source.src = videoData.video;
    source.type = 'video/mp4';

    video.appendChild(source);

    element.style.backgroundImage = '';

    element.replaceChildren(frame, video);
  });

  characterElements.combatCopy.forEach((element) => {
    const index = Number(element.dataset.characterCombatCopy);

    const video = character.combatVideos[index];

    element.innerHTML = video?.description ?? '';
  });

  const combatArtMotionMedia = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  );

  let combatArtObserver = null;

  function setupCombatArtAnimations() {
    if (combatArtObserver) {
      combatArtObserver.disconnect();
    }

    characterElements.combatArt.forEach((element) => {
      element.classList.remove('is-in-view');
    });

    if (combatArtMotionMedia.matches) {
      characterElements.combatArt.forEach((element) => {
        if (!element.hidden) {
          element.classList.add('is-in-view');
        }
      });

      return;
    }

    combatArtObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-in-view');

          combatArtObserver.unobserve(entry.target);
        });
      },
      {
        root: null,

        rootMargin: '0px 0px -28% 0px',

        threshold: 0.01,
      },
    );

    characterElements.combatArt.forEach((element) => {
      if (!element.hidden) {
        combatArtObserver.observe(element);
      }
    });
  }

  renderCombatArt(character);
  setupCombatArtAnimations();

  document.documentElement.style.setProperty(
    '--character-plaque-start',
    character.plaqueColor,
  );

  document.documentElement.style.setProperty(
    '--character-plaque-middle',
    character.plaqueColorMiddle,
  );

  document.documentElement.style.setProperty(
    '--character-plaque-end',
    character.plaqueColorDark,
  );

  document.documentElement.style.setProperty(
    '--character-plaque-border',
    character.borderColor,
  );

  document.documentElement.style.setProperty(
    '--character-banner-one-dark',
    character.bannerOneDark,
  );

  document.documentElement.style.setProperty(
    '--character-banner-one-middle',
    character.bannerOneMiddle,
  );

  document.documentElement.style.setProperty(
    '--character-banner-one-light',
    character.bannerOneLight,
  );

  document.documentElement.style.setProperty(
    '--character-banner-two-dark',
    character.bannerTwoDark,
  );

  document.documentElement.style.setProperty(
    '--character-banner-two-middle',
    character.bannerTwoMiddle,
  );

  document.documentElement.style.setProperty(
    '--character-banner-two-light',
    character.bannerTwoLight,
  );

  document.title = `${character.name} | Muramasa: Revenant Blades`;
}

/* =========================================
   Update active character tiles
========================================= */

function updateActiveTiles(characterKey) {
  characterTiles.forEach((tile) => {
    const isSelected = tile.dataset.character === characterKey;

    tile.classList.toggle('is-active', isSelected);

    tile.setAttribute('aria-pressed', String(isSelected));
  });
}

/* =========================================
   Character intro entrance animation helpers
========================================= */

let characterIntroObserver = null;

function getCharacterIntroSections() {
  return Array.from(
    document.querySelectorAll(
      '.character-scroll-intro, .character-scroll-intro-large',
    ),
  );
}

function resetCharacterIntroAnimation() {
  const characterIntros = getCharacterIntroSections();

  characterIntros.forEach((intro) => {
    /*
     * Disable transitions before removing
     * the visible state.
     */
    intro.classList.add('is-resetting');

    intro.classList.remove('is-visible');
  });

  /*
   * Force the browser to commit the hidden
   * starting position immediately.
   */
  characterIntros.forEach((intro) => {
    void intro.offsetWidth;
  });

  /*
   * Re-enable transitions, but leave the
   * elements in their hidden starting state.
   */
  characterIntros.forEach((intro) => {
    intro.classList.remove('is-resetting');
  });
}

function playCharacterIntroAnimation() {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  const characterIntros = getCharacterIntroSections();

  if (reducedMotion) {
    characterIntros.forEach((intro) => {
      intro.classList.add('is-visible');
    });

    return;
  }

  characterIntros.forEach((intro) => {
    const styles = window.getComputedStyle(intro);

    if (styles.display === 'none' || styles.visibility === 'hidden') {
      return;
    }

    const rect = intro.getBoundingClientRect();

    /*
     * If the parchment is already on screen when
     * the character changes, replay immediately
     * after the page fade has finished.
     *
     * If it is still offscreen, the persistent
     * IntersectionObserver will reveal it when
     * scrollIntoView brings it into view.
     */
    if (rect.bottom > 0 && rect.top < window.innerHeight * 0.9) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          intro.classList.add('is-visible');
        });
      });
    }
  });
}

function initCharacterIntroAnimations() {
  const characterIntros = getCharacterIntroSections();

  if (!characterIntros.length) {
    return;
  }

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  if (reducedMotion) {
    characterIntros.forEach((intro) => {
      intro.classList.add('is-visible');
    });

    return;
  }

  if (characterIntroObserver) {
    characterIntroObserver.disconnect();
  }

  /*
   * Keep observing instead of unobserving after
   * the first reveal. Character changes reset
   * is-visible, so the same section needs to be
   * able to animate again later.
   */
  characterIntroObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -15% 0px',
    },
  );

  characterIntros.forEach((intro) => {
    characterIntroObserver.observe(intro);
  });
}

/* =========================================
   Character transition
========================================= */
async function showCharacterContent(characterKey, shouldAnimate = true) {
  const character = characters[characterKey];

  if (!character) {
    return;
  }

  await preloadImages([
    character.images.character,

    character.images.scrollMobile,
    character.images.scrollDesktop,

    character.images.backgroundMobile,
    character.images.backgroundDesktop,

    ...character.storyVideos.map((video) => video.poster),

    ...character.combatVideos.map((video) => video.poster),

    ...(character.combatArt ?? []).map((art) => art.image),
  ]);

  if (!shouldAnimate || !characterPage) {
    updateCharacterContent(characterKey);

    activeCharacter = characterKey;

    return;
  }

  /* Fade old page out */
  characterPage.classList.add('is-changing');

  await waitForOpacityTransition(characterPage);

  /*
   * PAGE IS NOW INVISIBLE.
   *
   * Reset character/text instantly.
   * There is NO reverse animation here.
   */
  resetCharacterIntroAnimation();

  /* Swap all content while invisible */
  updateCharacterContent(characterKey);

  activeCharacter = characterKey;

  /* Fade page back in */
  characterPage.classList.remove('is-changing');

  /*
   * Let the page begin fading back in,
   * but don't wait for the entire fade
   * before continuing to the intro animation.
   */
  await new Promise((resolve) => {
    window.setTimeout(resolve, 50);
  });

  isTransitioning = false;
}

/* =========================================
   Select character
========================================= */

async function selectCharacter(
  characterKey,
  { updateUrl = true, animate = true } = {},
) {
  if (!characters[characterKey]) {
    return;
  }

  /*
   * If this character is already active,
   * there is nothing to re-render.
   *
   * The click handler can still scroll
   * to the character parchment afterward.
   */
  if (characterKey === activeCharacter) {
    return;
  }

  /*
   * Prevent another character change
   * while the current transition is running.
   */
  if (isTransitioning) {
    return;
  }

  isTransitioning = true;

  /*
   * Both copies of the character
   * selector update together.
   */
  updateActiveTiles(characterKey);

  /*
   * Add selected character
   * to the URL.
   */
  if (updateUrl) {
    const url = new URL(window.location.href);

    url.searchParams.set('character', characterKey);

    window.history.pushState(
      {
        character: characterKey,
      },
      '',
      url,
    );
  }

  await showCharacterContent(characterKey, animate);

  if (!animate) {
    isTransitioning = false;
  }
}

/* =========================================
   Find visible character scroll section
========================================= */

function getCharacterScrollTarget() {
  const mobileIntro = document.querySelector('.character-scroll-intro');

  const desktopIntro = document.querySelector('.character-scroll-intro-large');

  /*
   * Both versions exist in the HTML,
   * so use whichever one is currently
   * visible at this breakpoint.
   */
  const targets = [mobileIntro, desktopIntro];

  const visibleTarget = targets.find((element) => {
    if (!element) {
      return false;
    }

    const styles = window.getComputedStyle(element);

    return styles.display !== 'none' && styles.visibility !== 'hidden';
  });

  return visibleTarget ?? desktopIntro ?? mobileIntro;
}

/* =========================================
   Scroll to character intro
========================================= */

function scrollToCharacterIntro() {
  const target = getCharacterScrollTarget();

  if (!target) {
    return;
  }

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  target.scrollIntoView({
    behavior: reducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });
}

/* =========================================
   Tile click events
========================================= */

characterTiles.forEach((tile) => {
  tile.addEventListener('click', async () => {
    const characterKey = tile.dataset.character;

    if (isTransitioning) {
      return;
    }

    /*
     * Fade out, reset while invisible,
     * swap content, begin fading back in.
     */
    await selectCharacter(characterKey);

    /*
     * Begin moving toward the parchment.
     */
    scrollToCharacterIntro();

    /*
     * Start the character entrance almost
     * immediately with the scroll.
     */
    window.setTimeout(() => {
      playCharacterIntroAnimation();
    }, 75);
  });
});
/* =========================================
   Initial character
========================================= */

function initializeCharacterPage() {
  if (!characterPage) {
    return;
  }

  const url = new URL(window.location.href);

  const requestedCharacter = url.searchParams.get('character');

  const initialCharacter =
    requestedCharacter && characters[requestedCharacter]
      ? requestedCharacter
      : 'kisuke';

  activeCharacter = initialCharacter;

  updateCharacterContent(initialCharacter);

  updateActiveTiles(initialCharacter);

  // If a character was specifically requested from another page,
  // move directly to the character description.
  if (requestedCharacter && characters[requestedCharacter]) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToCharacterIntro();
        playCharacterIntroAnimation();
      });
    });
  }
}

initializeCharacterPage();
setupCharacterMotifMotion();

/* =========================================
   Resume character videos after iOS sleep
========================================= */

function resumeCharacterVideos() {
  if (document.visibilityState !== 'visible') {
    return;
  }

  const videos = document.querySelectorAll(
    '.story-feature__video video, .combat-feature__video video',
  );

  videos.forEach((video) => {
    if (!video.paused && !video.ended) {
      return;
    }

    video.muted = true;

    const playPromise = video.play();

    if (playPromise) {
      playPromise.catch(() => {
        // Safari may still be restoring its media session.
      });
    }
  });
}

document.addEventListener('visibilitychange', resumeCharacterVideos);

window.addEventListener('pageshow', resumeCharacterVideos);

/* =========================================
   Combat artwork responsive breakpoint
========================================= */

function refreshCombatArt() {
  if (!activeCharacter) {
    return;
  }

  const character = characters[activeCharacter];

  if (!character) {
    return;
  }

  renderCombatArt(character);
}

combatTabletMedia.addEventListener('change', refreshCombatArt);
combatMobileMedia.addEventListener('change', refreshCombatArt);
combatSmallMobileMedia.addEventListener('change', refreshCombatArt);

/* =========================================
   Browser back / forward
========================================= */

window.addEventListener('popstate', () => {
  const requestedCharacter = new URLSearchParams(window.location.search).get(
    'character',
  );

  const characterKey =
    requestedCharacter && characters[requestedCharacter]
      ? requestedCharacter
      : 'kisuke';

  selectCharacter(characterKey, {
    updateUrl: false,
    animate: true,
  });
});

/* =========================================
   Character tile hover animation
========================================= */

document.querySelectorAll('.character-tile').forEach((tile) => {
  tile.addEventListener('mouseenter', () => {
    tile.classList.remove('is-leaving');

    tile.classList.add('is-hovering');
  });

  tile.addEventListener('mouseleave', () => {
    tile.classList.remove('is-hovering');

    tile.classList.add('is-leaving');
  });
});

/* =========================================================
   Character intro entrance animation
========================================================= */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCharacterIntroAnimations);
} else {
  initCharacterIntroAnimations();
}
